module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar icon                = formMapping.icon;\nvar buttonType          = formMapping.buttonType;\nvar context             = formMapping.context;\nvar buttonContext       = formMapping.buttonContext;\nvar mode                = formMapping.mode;\nvar symbolOnly          = !!formMapping.symbolOnly;\nvar buttonTextKey       = formMapping.buttonText || 'button:' + (buttonType || 'all') + '.' + (buttonContext || context || 'all') + '.' + (mode || 'all');\nvar buttonText          = __(buttonTextKey);\nvar title               = formMapping.title || buttonText || '';\nvar neutral             = !!formMapping.neutral;\nvar negative            = !!formMapping.negative;\nvar positive            = !!formMapping.positive;\nvar defaultIconClass    = 'fi fi-' + (buttonType ? buttonType + '-' : '') + ((buttonContext || context) ? (buttonContext || context) : 'default');\nif(!icon && buttonType){\nswitch(buttonType){\ncase 'pay':\nicon = 'fi fi-pay';\nbreak;\ncase 'import':\ncase 'showImport':\nicon = 'fi fi-upload';\nbreak;\ncase 'download':\ncase 'export':\nicon = 'fi fi-download';\nswitch(mode) {\ncase 'copy':    icon = 'fi fi-download'; break;\ncase 'csv':     icon = 'fi fi-download'; break;\ncase 'excel':   icon = 'fi fi-download'; break;\ncase 'pdf':     icon = 'fi fi-download'; break;\ncase 'print':   icon = 'fi fi-download'; break;\n}\nbreak;\ncase 'cancel':\ncase 'no':\ncase 'close':                   icon = 'fi fi-times'; negative = true; break;\ncase 'done':                    icon = 'fi fi-check'; positive = true; break;\ncase 'connectLanguage':         icon = 'fi fi-connect-language'; break;\ncase 'connectLayout':           icon = 'fi fi-connect-layout'; break;\ncase 'delete':\nicon = 'fi fi-trash';\nnegative = true;\nswitch(context) {\ncase 'segmentData':     icon = 'fi fi-times'; break;\n}\nbreak;\ncase 'showDuplicate':\ncase 'duplicate':               icon = 'fi fi-copy'; break;\ncase 'assign':\ncase 'showAssign':\nicon = 'fi fi-assign';\nswitch(context) {\ncase 'tags':\nicon = 'fi fi-assign-tags'\nswitch(mode) {\ncase 'empty':\nicon = 'fi fi-trash'\nbreak;\ncase 'selected':\nicon = 'fi fi-filter'\nbreak;\n}\nbreak;\ncase 'routes':\nicon = 'fi fi-assign-tags'\nswitch(mode) {\ncase 'empty':\nicon = 'fi fi-trash'\nbreak;\ncase 'selected':\nicon = 'fi fi-filter'\nbreak;\n}\nbreak;\n}\nbreak;\ncase 'showFilter':\nicon = 'fi fi-filter';\nswitch(context) {\ncase 'tags':\nswitch(mode) {\ncase 'empty':\nicon = 'fi fi-trash'\nbreak;\n}\nbreak;\n}\nbreak;\ncase 'filter':                  icon = 'fi fi-filter'; break;\ncase 'fullScreen':              icon = 'fi fi-full-screen'; break;\ncase 'closeFullScreen':         icon = 'fi fi-close-full-screen'; break;\ncase 'showEdit':\ncase 'edit':\nicon = 'fi fi-edit';\nswitch(context) {\ncase 'serviceUsers':\nicon = 'fi fi-users';\nbreak;\ncase 'categoryData':\nswitch(mode) {\ncase 'asDefault':   icon = 'fi fi-setDefault-categoryData'; break;\n}\nbreak;\ncase 'route':\nswitch(mode) {\ncase 'asHome':      icon = 'fi fi-home'; break;\n}\nbreak;\ncase 'media-image':\nswitch(mode) {\ncase 'assign':      icon = 'fi fi-mediaImage'; break;\n}\nbreak;\ncase 'media-file':\nswitch(mode) {\ncase 'assign':      icon = 'fi fi-mediaFile'; break;\n}\nbreak;\ncase 'address':\nswitch(mode) {\ncase 'details':      icon = 'fi fi-mailing-address'; break;\n}\nbreak;\ncase 'mailingUrl':\nicon = 'fi fi-mailingUrl-viewSubscribers'\nbreak;\ncase 'subProducts':\nicon = 'fi fi-shop-product'\nbreak;\n}\nbreak;\ncase 'showPreview':\nicon = 'fi fi-search'\nbreak;\ncase 'showMove':\nicon = 'fi fi-move';\nbreak;\ncase 'move':\nicon = 'fi fi-move-all';\nswitch(mode) {\ncase 'up':          icon = 'fi fi-move-up'; break;\ncase 'down':        icon = 'fi fi-move-down'; break;\ncase 'left':        icon = 'fi fi-move-left'; break;\ncase 'right':       icon = 'fi fi-move-right'; break;\n}\nbreak;\ncase 'moveToStart':\nicon = 'fi fi-arrow-up-stop';\nbreak;\ncase 'moveToBefore':\nicon = 'fi fi-arrow-up';\nbreak;\ncase 'moveToAfter':\nicon = 'fi fi-arrow-down';\nbreak;\ncase 'moveToEnd':\nicon = 'fi fi-arrow-down-stop';\nbreak;\ncase 'showSelect':\ncase 'select':\nicon = 'fi fi-select';\nswitch(context) {\ncase 'products':\nswitch(mode) {\ncase 'empty':\nicon = 'fi fi-trash';\nbreak;\n}\nbreak;\n}\nbreak;\ncase 'showInsert':\ncase 'insert':\nicon = 'fi fi-file-o';\nswitch(context) {\ncase 'section':         icon = 'fi fi-section'; break;\ncase 'category':        icon = 'fi fi-category'; break;\ncase 'categoryData':    icon = 'fi fi-categoryData'; break;\ncase 'database':        icon = 'fi fi-database'; break;\ncase 'atom':            icon = 'fi fi-atom'; break;\ncase 'component':       icon = 'fi fi-component'; break;\ncase 'layout':          icon = 'fi fi-layout'; break;\ncase 'service':         icon = 'fi fi-service'; break;\ncase 'assignedService': icon = 'fi fi-assignedService'; break;\ncase 'scope':           icon = 'fi fi-scope'; break;\ncase 'scopeRole':       icon = 'fi fi-scopeRole'; break;\ncase 'privilege':       icon = 'fi fi-privilege'; break;\ncase 'user':            icon = 'fi fi-user'; break;\ncase 'serviceUser':     icon = 'fi fi-serviceUser'; break;\ncase 'validator':       icon = 'fi fi-validator'; break;\ncase 'banner':          icon = 'fi fi-banner'; break;\ncase 'client':          icon = 'fi fi-client'; break;\ncase 'newsletter':      icon = 'fi fi-newsletter'; break;\ncase 'address':         icon = 'fi fi-plus-circle'; break;\ncase 'activity':        icon = 'fi fi-plus-circle'; break;\ncase 'trip':            icon = 'fi fi-plus-circle'; break;\ncase 'product':         icon = 'fi fi-shop-product'; break;\ncase 'productState':\ncase 'productPrice':    icon = 'fi fi-plus-circle'; break;\n}\nbreak;\ncase 'signIn':                  icon = 'fi fi-sign-in'; positive = true; break;\ncase 'submit':\ncase 'save':\nicon = 'fi fi-check';\npositive = true;\nswitch(context) {\ncase 'signIn':          icon = 'fi fi-sign-in'; break;\n}\nbreak;\ncase 'yes':                     icon = 'fi fi-check'; positive = true; break;\ncase 'users':                   icon = 'fi fi-users'; break;\ncase 'renew':\ncase 'refresh':\ncase 'refreshData':\nicon = 'fi fi-refresh';\nbreak;\ncase 'lazyload':{\nicon = 'fi fi-lazyload';\nbreak;\n}\ncase 'send':\ncase 'schedule':\nicon = 'fi fi-check';\nbreak;\ncase 'abort':\ncase 'unschedule':\nicon = 'fi fi-times';\nnegative = true;\nbreak;\ncase 'reset':\nicon = 'fi fi-reset';\nnegative = true;\nbreak;\ncase 'resend':\nicon = 'fi fi-resend';\nnegative = true;\nbreak;\ncase 'decisionComponent':\ncase 'default':\ndefault:                        icon = defaultIconClass; break;\n}\n}\nvar additionalClasses = [];\nif(!neutral){\nif(negative) additionalClasses.push('negative');\nelse if(positive) additionalClasses.push('positive');\n}\nif(symbolOnly){\nadditionalClasses.push('symbolOnly');\n}\n%>\n<button class=\"<%- additionalClasses.join(' '); %>\" data-field-type=\"<%- buttonType %>\" data-button-context=\"<%- context %>\" data-button-mode=\"<%- mode %>\" title=\"<%= title %>\">\n<i class=\"<%- icon %>\"></i>\n<%= (!symbolOnly ? title : '') %>\n</button>"
  , __filename = "node_modules/frontend-controller/baseComponents/form/elements/buttons/default.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var icon                = formMapping.icon;
var buttonType          = formMapping.buttonType;
var context             = formMapping.context;
var buttonContext       = formMapping.buttonContext;
var mode                = formMapping.mode;
var symbolOnly          = !!formMapping.symbolOnly;
var buttonTextKey       = formMapping.buttonText || 'button:' + (buttonType || 'all') + '.' + (buttonContext || context || 'all') + '.' + (mode || 'all');
var buttonText          = __(buttonTextKey);
var title               = formMapping.title || buttonText || '';
var neutral             = !!formMapping.neutral;
var negative            = !!formMapping.negative;
var positive            = !!formMapping.positive;
var defaultIconClass    = 'fi fi-' + (buttonType ? buttonType + '-' : '') + ((buttonContext || context) ? (buttonContext || context) : 'default');
if(!icon && buttonType){
switch(buttonType){
case 'pay':
icon = 'fi fi-pay';
break;
case 'import':
case 'showImport':
icon = 'fi fi-upload';
break;
case 'download':
case 'export':
icon = 'fi fi-download';
switch(mode) {
case 'copy':    icon = 'fi fi-download'; break;
case 'csv':     icon = 'fi fi-download'; break;
case 'excel':   icon = 'fi fi-download'; break;
case 'pdf':     icon = 'fi fi-download'; break;
case 'print':   icon = 'fi fi-download'; break;
}
break;
case 'cancel':
case 'no':
case 'close':                   icon = 'fi fi-times'; negative = true; break;
case 'done':                    icon = 'fi fi-check'; positive = true; break;
case 'connectLanguage':         icon = 'fi fi-connect-language'; break;
case 'connectLayout':           icon = 'fi fi-connect-layout'; break;
case 'delete':
icon = 'fi fi-trash';
negative = true;
switch(context) {
case 'segmentData':     icon = 'fi fi-times'; break;
}
break;
case 'showDuplicate':
case 'duplicate':               icon = 'fi fi-copy'; break;
case 'assign':
case 'showAssign':
icon = 'fi fi-assign';
switch(context) {
case 'tags':
icon = 'fi fi-assign-tags'
switch(mode) {
case 'empty':
icon = 'fi fi-trash'
break;
case 'selected':
icon = 'fi fi-filter'
break;
}
break;
case 'routes':
icon = 'fi fi-assign-tags'
switch(mode) {
case 'empty':
icon = 'fi fi-trash'
break;
case 'selected':
icon = 'fi fi-filter'
break;
}
break;
}
break;
case 'showFilter':
icon = 'fi fi-filter';
switch(context) {
case 'tags':
switch(mode) {
case 'empty':
icon = 'fi fi-trash'
break;
}
break;
}
break;
case 'filter':                  icon = 'fi fi-filter'; break;
case 'fullScreen':              icon = 'fi fi-full-screen'; break;
case 'closeFullScreen':         icon = 'fi fi-close-full-screen'; break;
case 'showEdit':
case 'edit':
icon = 'fi fi-edit';
switch(context) {
case 'serviceUsers':
icon = 'fi fi-users';
break;
case 'categoryData':
switch(mode) {
case 'asDefault':   icon = 'fi fi-setDefault-categoryData'; break;
}
break;
case 'route':
switch(mode) {
case 'asHome':      icon = 'fi fi-home'; break;
}
break;
case 'media-image':
switch(mode) {
case 'assign':      icon = 'fi fi-mediaImage'; break;
}
break;
case 'media-file':
switch(mode) {
case 'assign':      icon = 'fi fi-mediaFile'; break;
}
break;
case 'address':
switch(mode) {
case 'details':      icon = 'fi fi-mailing-address'; break;
}
break;
case 'mailingUrl':
icon = 'fi fi-mailingUrl-viewSubscribers'
break;
case 'subProducts':
icon = 'fi fi-shop-product'
break;
}
break;
case 'showPreview':
icon = 'fi fi-search'
break;
case 'showMove':
icon = 'fi fi-move';
break;
case 'move':
icon = 'fi fi-move-all';
switch(mode) {
case 'up':          icon = 'fi fi-move-up'; break;
case 'down':        icon = 'fi fi-move-down'; break;
case 'left':        icon = 'fi fi-move-left'; break;
case 'right':       icon = 'fi fi-move-right'; break;
}
break;
case 'moveToStart':
icon = 'fi fi-arrow-up-stop';
break;
case 'moveToBefore':
icon = 'fi fi-arrow-up';
break;
case 'moveToAfter':
icon = 'fi fi-arrow-down';
break;
case 'moveToEnd':
icon = 'fi fi-arrow-down-stop';
break;
case 'showSelect':
case 'select':
icon = 'fi fi-select';
switch(context) {
case 'products':
switch(mode) {
case 'empty':
icon = 'fi fi-trash';
break;
}
break;
}
break;
case 'showInsert':
case 'insert':
icon = 'fi fi-file-o';
switch(context) {
case 'section':         icon = 'fi fi-section'; break;
case 'category':        icon = 'fi fi-category'; break;
case 'categoryData':    icon = 'fi fi-categoryData'; break;
case 'database':        icon = 'fi fi-database'; break;
case 'atom':            icon = 'fi fi-atom'; break;
case 'component':       icon = 'fi fi-component'; break;
case 'layout':          icon = 'fi fi-layout'; break;
case 'service':         icon = 'fi fi-service'; break;
case 'assignedService': icon = 'fi fi-assignedService'; break;
case 'scope':           icon = 'fi fi-scope'; break;
case 'scopeRole':       icon = 'fi fi-scopeRole'; break;
case 'privilege':       icon = 'fi fi-privilege'; break;
case 'user':            icon = 'fi fi-user'; break;
case 'serviceUser':     icon = 'fi fi-serviceUser'; break;
case 'validator':       icon = 'fi fi-validator'; break;
case 'banner':          icon = 'fi fi-banner'; break;
case 'client':          icon = 'fi fi-client'; break;
case 'newsletter':      icon = 'fi fi-newsletter'; break;
case 'address':         icon = 'fi fi-plus-circle'; break;
case 'activity':        icon = 'fi fi-plus-circle'; break;
case 'trip':            icon = 'fi fi-plus-circle'; break;
case 'product':         icon = 'fi fi-shop-product'; break;
case 'productState':
case 'productPrice':    icon = 'fi fi-plus-circle'; break;
}
break;
case 'signIn':                  icon = 'fi fi-sign-in'; positive = true; break;
case 'submit':
case 'save':
icon = 'fi fi-check';
positive = true;
switch(context) {
case 'signIn':          icon = 'fi fi-sign-in'; break;
}
break;
case 'yes':                     icon = 'fi fi-check'; positive = true; break;
case 'users':                   icon = 'fi fi-users'; break;
case 'renew':
case 'refresh':
case 'refreshData':
icon = 'fi fi-refresh';
break;
case 'lazyload':{
icon = 'fi fi-lazyload';
break;
}
case 'send':
case 'schedule':
icon = 'fi fi-check';
break;
case 'abort':
case 'unschedule':
icon = 'fi fi-times';
negative = true;
break;
case 'reset':
icon = 'fi fi-reset';
negative = true;
break;
case 'resend':
icon = 'fi fi-resend';
negative = true;
break;
case 'decisionComponent':
case 'default':
default:                        icon = defaultIconClass; break;
}
}
var additionalClasses = [];
if(!neutral){
if(negative) additionalClasses.push('negative');
else if(positive) additionalClasses.push('positive');
}
if(symbolOnly){
additionalClasses.push('symbolOnly');
}

    ; __line = 253
    ; __append("\n<button class=\"")
    ; __line = 254
    ; __append( additionalClasses.join(' ') )
    ; __append("\" data-field-type=\"")
    ; __append( buttonType )
    ; __append("\" data-button-context=\"")
    ; __append( context )
    ; __append("\" data-button-mode=\"")
    ; __append( mode )
    ; __append("\" title=\"")
    ; __append(escapeFn( title ))
    ; __append("\">\n<i class=\"")
    ; __line = 255
    ; __append( icon )
    ; __append("\"></i>\n")
    ; __line = 256
    ; __append(escapeFn( (!symbolOnly ? title : '') ))
    ; __append("\n</button>")
    ; __line = 257
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=node_modules/frontend-controller/baseComponents/form/elements/buttons/default.ejs

}